// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"873fb7f0","105":"07be0053","164":"dd1d5e60","304":"4ce2b49b","519":"40153135","787":"b2c3f5bb"}[chunkId] + ".chunk.js";
};